
<template>
  <v-app style="margin: 0px; padding: 0px; width: 100%; height: 100%">
    <v-main>
      <v-container
        fluid
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        "
        :class="$vuetify.breakpoint.xs ? 'pa-0 ma-0' : ''"
      >
        <v-card
          :class="$vuetify.breakpoint.xs ? 'ma-0 pa-5' : 'mt-10 px-5'"
          outlined
          elevation="2"
          class="mb-10"
          :width="$vuetify.breakpoint.xs ? '100%' : '520px'"
          :style="
            $vuetify.breakpoint.xs ? 'padding: 0; margin: 0;' : 'padding: auto;'
          "
        >
          <v-form
            class="signup-form text-center"
            method="POST"
            :action="pageSignupRoute"
          >
            <input type="hidden" name="_token" :value="csrf" />
            <v-card-title class="justify-center font-weight-bold pb-1"
              >Start accepting anonymous submissions</v-card-title
            >

            <v-card-text class="mb-3 px-1">
              Name your new submission form, or leave it blank and change it
              later
            </v-card-text>

            <v-text-field
              name="page_name"
              label="Form Name (Optional)"
              outlined
            ></v-text-field>
            <v-btn type="submit" color="primary" class="mb-5" large>
              Create New Form</v-btn
            >

            <div class="row-wrapper-smaller flex-column">
              <span
                v-for="e in this.getErrors(errors)"
                :key="e"
                class="error-text"
                >{{ e }}
              </span>
            </div>
          </v-form>
        </v-card>
        <span class="h4 pt-4 pb-0">Joining an existing admin team?</span><br />
        <span
          >Ask one of the admins on the team to send you an invite link.</span
        >
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  props: {
    errors: String,
    "page-signup-route": String,
    csrf: String,
  },
  methods: {
    getErrors(e) {
      if (e !== undefined) {
        return [].concat.apply([], Object.values(JSON.parse(e)));
      }
    },
  },
};
</script>